import { createStaticReducer } from '../../utils/redux/createStaticReducer';

export const noResizeReducer = createStaticReducer<boolean>(false);
